import React from "react";

const Catalog = ({ strings }) => {
  return (
    <section className="grid grid--selection">
      <div className="autoContainer">
        <div className="grid__inner">
          <h3>{strings.title}</h3>
          <div className="grid__inner-row">
            <div className="gridItem">
              <div className="gridItem__image">
                <div className="ratioImage">
                  <img src="/images/investments/investments-1.png" alt="" />
                </div>
              </div>
              <div className="gridItem__info">
                <h4>{strings["item-1"].title}</h4>
                <p className="_sm">
                  <strong>{strings["item-1"]["paragraphStrong-1"]}</strong>
                  {strings["item-1"]["paragraph-1"]}
                </p>
                <div className="gridItem__info-row">
                  <p className="_sm">
                    <strong>{strings["item-1"]["paragraphStrong-2"]}</strong>
                    {strings["item-1"]["paragraph-2"]}
                  </p>
                  <p className="_sm">
                    <strong>{strings["item-1"]["paragraphStrong-3"]}</strong>
                    {strings["item-1"]["paragraph-3"]}
                  </p>
                </div>
              </div>
            </div>
            <div className="gridItem">
              <div className="gridItem__image">
                <div className="ratioImage">
                  <img src="/images/investments/investments-2.png" alt="" />
                </div>
              </div>
              <div className="gridItem__info">
                <h4>{strings["item-2"].title}</h4>
                <p className="_sm">
                  <strong>{strings["item-2"]["paragraphStrong-1"]}</strong>
                  {strings["item-2"]["paragraph-1"]}
                </p>
                <div className="gridItem__info-row">
                  <p className="_sm">
                    <strong>{strings["item-2"]["paragraphStrong-2"]}</strong>
                    {strings["item-2"]["paragraph-2"]}
                  </p>
                  <p className="_sm">
                    <strong>{strings["item-1"]["paragraphStrong-3"]}</strong>
                    {strings["item-2"]["paragraph-3"]}
                  </p>
                </div>
              </div>
            </div>
            <div className="gridItem">
              <div className="gridItem__image">
                <div className="ratioImage">
                  <img src="/images/investments/investments-3.png" alt="" />
                </div>
              </div>
              <div className="gridItem__info">
                <h4>{strings["item-3"].title}</h4>
                <p className="_sm">
                  <strong>{strings["item-3"]["paragraphStrong-1"]}</strong>
                  {strings["item-3"]["paragraph-1"]}
                </p>
                <div className="gridItem__info-row">
                  <p className="_sm">
                    <strong>{strings["item-3"]["paragraphStrong-2"]}</strong>
                    {strings["item-3"]["paragraph-2"]}
                  </p>
                  <p className="_sm">
                    <strong>{strings["item-1"]["paragraphStrong-3"]}</strong>
                    {strings["item-3"]["paragraph-3"]}
                  </p>
                </div>
              </div>
            </div>
            <div className="gridItem">
              <div className="gridItem__image">
                <div className="ratioImage">
                  <img src="/images/investments/investments-4.png" alt="" />
                </div>
              </div>
              <div className="gridItem__info">
                <h4>{strings["item-4"].title}</h4>
                <p className="_sm">
                  <strong>{strings["item-4"]["paragraphStrong-1"]}</strong>
                  {strings["item-4"]["paragraph-1"]}
                </p>
                <div className="gridItem__info-row">
                  <p className="_sm">
                    <strong>{strings["item-4"]["paragraphStrong-2"]}</strong>
                    {strings["item-4"]["paragraph-2"]}
                  </p>
                  <p className="_sm">
                    <strong>{strings["item-1"]["paragraphStrong-3"]}</strong>
                    {strings["item-4"]["paragraph-3"]}
                  </p>
                </div>
              </div>
            </div>
            <div className="gridItem">
              <div className="gridItem__image">
                <div className="ratioImage">
                  <img src="/images/investments/investments-5.png" alt="" />
                </div>
              </div>
              <div className="gridItem__info">
                <h4>{strings["item-5"].title}</h4>
                <p className="_sm">
                  <strong>{strings["item-5"]["paragraphStrong-1"]}</strong>
                  {strings["item-5"]["paragraph-1"]}
                </p>
                <div className="gridItem__info-row">
                  <p className="_sm">
                    <strong>{strings["item-5"]["paragraphStrong-2"]}</strong>
                    {strings["item-5"]["paragraph-2"]}
                  </p>
                  <p className="_sm">
                    <strong>{strings["item-1"]["paragraphStrong-3"]}</strong>
                    {strings["item-5"]["paragraph-3"]}
                  </p>
                </div>
              </div>
            </div>
            <div className="gridItem">
              <div className="gridItem__image">
                <div className="ratioImage">
                  <img src="/images/investments/investments-6.png" alt="" />
                </div>
              </div>
              <div className="gridItem__info">
                <h4>{strings["item-6"].title}</h4>
                <p className="_sm">
                  <strong>{strings["item-6"]["paragraphStrong-1"]}</strong>
                  {strings["item-6"]["paragraph-1"]}
                </p>
                <div className="gridItem__info-row">
                  <p className="_sm">
                    <strong>{strings["item-6"]["paragraphStrong-2"]}</strong>
                    {strings["item-6"]["paragraph-2"]}
                  </p>
                  <p className="_sm">
                    <strong>{strings["item-1"]["paragraphStrong-3"]}</strong>
                    {strings["item-6"]["paragraph-3"]}
                  </p>
                </div>
              </div>
            </div>
            <div className="gridItem">
              <div className="gridItem__image">
                <div className="ratioImage">
                  <img src="/images/investments/investments-7.png" alt="" />
                </div>
              </div>
              <div className="gridItem__info">
                <h4>{strings["item-7"].title}</h4>
                <p className="_sm">
                  <strong>{strings["item-7"]["paragraphStrong-1"]}</strong>
                  {strings["item-7"]["paragraph-1"]}
                </p>
                <div className="gridItem__info-row">
                  <p className="_sm">
                    <strong>{strings["item-7"]["paragraphStrong-2"]}</strong>
                    {strings["item-7"]["paragraph-2"]}
                  </p>
                  <p className="_sm">
                    <strong>{strings["item-1"]["paragraphStrong-3"]}</strong>
                    {strings["item-7"]["paragraph-3"]}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Catalog;
